export default __webpack_public_path__ + "static/media/Rish Rao.8e5268a1.jpg";